/* __next_internal_client_entry_do_not_use__ useShowDeferredContent,DeferredRenderContextProvider auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, startTransition, useContext, useEffect, useState } from "react";
var DeferredRenderContext = /*#__PURE__*/ createContext({
    showContent: false
});
export var useShowDeferredContent = function() {
    return useContext(DeferredRenderContext).showContent;
};
export var DeferredRenderContextProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(false), 2), showContent = _useState[0], setShowContent = _useState[1];
    /**
     * Wait for 100ms to allow React to hydrate / render most of the initial content.
     * Then, start a transition to render the deferred content.
     */ useEffect(function() {
        setTimeout(function() {
            startTransition(function() {
                setShowContent(true);
            });
        }, 100);
    }, []);
    return /*#__PURE__*/ _jsx(DeferredRenderContext.Provider, {
        value: {
            showContent: showContent
        },
        children: children
    });
};
